import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { SelectContent, SelectGroup, SelectItem, SelectTrigger, Select as SelectUI, SelectValue } from "../ui/select";
const valueToString = (val) => {
    if (val === null)
        return "__null__";
    if (val === undefined)
        return "__undefined__";
    if (val === Infinity)
        return "__Infinity__";
    if (val === -Infinity)
        return "__-Infinity__";
    if (Number.isNaN(val))
        return "__NaN__";
    if (typeof val === "symbol")
        return `__symbol__${val.description}`;
    return JSON.stringify(val);
};
const stringToValue = (str) => {
    switch (str) {
        case "__null__":
            return null;
        case "__undefined__":
            return undefined;
        case "__Infinity__":
            return Infinity;
        case "__-Infinity__":
            return -Infinity;
        case "__NaN__":
            return NaN;
        default:
            if (str.startsWith("__symbol__")) {
                return Symbol(str.slice(10));
            }
            return JSON.parse(str);
    }
};
function IgorSelectInner({ options, placeholder, onChange, value, triggerOptions, className, ...radixProps }, ref) {
    const handleValueChange = (value) => {
        if (onChange) {
            onChange(stringToValue(value));
        }
    };
    const activeTriggerLabel = triggerOptions ? triggerOptions.find((o) => o.value === value)?.label : null;
    return (_jsxs(SelectUI, { value: value === undefined ? undefined : valueToString(value), onValueChange: handleValueChange, ...radixProps, children: [_jsx(SelectTrigger, { ref: ref, className: cn("cursor-pointer", className), children: activeTriggerLabel || _jsx(SelectValue, { placeholder: placeholder }) }), _jsx(SelectContent, { children: _jsx(SelectGroup, { children: options.map((option) => (_jsx(SelectItem, { value: valueToString(option.value), disabled: option.disabled, className: "cursor-pointer", children: option.label }, valueToString(option.value)))) }) })] }));
}
export const IgorSelect = forwardRef(IgorSelectInner);
